import { MIN_USERNAME_LENGTH } from '@colonist/consts';
import { isValueStringBetween } from '@colonist/validation';
import { StringUtils } from '@colonist/utils';
export class ChangeUsernameService {
    setInitialData(data) {
        this.currentUsername = data.currentUsername;
        this.state.username = data.currentUsername;
        this.state.isGuest = data.isGuest;
        this.state.freeChangesLeft = data.freeChangesLeft;
        this.state.maxLength = data.maxLength;
        this.state.colonistCoins = data.colonistCoins;
        this.state.changePrice = data.changePrice;
        this.notifyChange();
    }
    getState() {
        return {
            ...this.state
        };
    }
    getChangeScenario() {
        if (this.state.isGuest && this.state.freeChangesLeft == 0) return 'login';
        if (this.state.freeChangesLeft > 0) return 'free';
        if (this.state.colonistCoins >= this.state.changePrice) return 'coins';
        return 'notEnoughCoins';
    }
    setUsername(name, isValid = false) {
        this.state.username = name;
        this.state.hasEdited = true;
        this.state.suggestedUsernames = [];
        if (isValid) {
            this.validationRequestId += 1;
            this.state.validationResult = {
                type: 'valid'
            };
            this.state.isValidating = false;
            this.notifyChange();
            return;
        }
        this.state.isValidating = true;
        this.notifyChange();
        void this.runValidation(name);
    }
    async runValidation(name) {
        this.validationRequestId += 1;
        const requestId = this.validationRequestId;
        const result = await this.getValidationResult(name);
        if (this.validationRequestId != requestId) return;
        this.state.validationResult = result;
        this.state.isValidating = false;
        this.state.suggestedUsernames = result.type == 'isTaken' ? result.suggestedUsernames : [];
        this.notifyChange();
    }
    getValidationResult(name) {
        if (name.toLowerCase() == this.currentUsername.toLowerCase()) return {
            type: 'isSame'
        };
        if (StringUtils.getNonAlphanumericCharacterCount(name) != 0) return {
            type: 'nonAlphanumeric'
        };
        if (!isValueStringBetween(name, MIN_USERNAME_LENGTH, this.state.maxLength)) return {
            type: 'invalidLength'
        };
        return this.deps.validateUsername(name);
    }
    submit() {
        if (this.state.validationResult.type != 'valid') return;
        if (this.state.isValidating) return;
        const shouldPurchase = this.state.freeChangesLeft <= 0;
        void this.deps.submitUsernameChange(this.state.username, shouldPurchase);
    }
    cancel() {
        this.deps.onCancel();
    }
    reset() {
        this.validationRequestId += 1;
        this.state.username = this.currentUsername;
        this.state.validationResult = {
            type: 'isSame'
        };
        this.state.isValidating = false;
        this.state.hasEdited = false;
        this.state.suggestedUsernames = [];
        this.notifyChange();
    }
    dispose() {
        this.validationRequestId += 1;
    }
    notifyChange() {
        this.deps.onStateChange(this.getState());
    }
    constructor(deps){
        this.state = {
            username: '',
            hasEdited: false,
            isGuest: false,
            freeChangesLeft: 0,
            maxLength: 0,
            colonistCoins: 0,
            changePrice: 0,
            isValidating: false,
            validationResult: {
                type: 'isSame'
            },
            suggestedUsernames: []
        };
        this.currentUsername = '';
        this.validationRequestId = 0;
        this.deps = deps;
    }
}
